import React from "react";
import {
  Box,
  Divider,
  Drawer,
  Grid,
  List,
  ListItemIcon,
  ListItemText,
  MenuItem,
  useTheme,
} from "@mui/material";
import { useLocation } from "react-use";
import { useHistory } from "react-router-dom";
import Icon from "../../../components/Icon";

const drawerWidth = 250;

interface SideMenuProps {
  collapsed: boolean;
  menuItems: any[];
}

export default function SideMenuNavigation({
  menuItems,
  collapsed,
}: SideMenuProps) {
  const location = useLocation();
  const theme = useTheme();
  const history = useHistory();

  const rows: any = {};

  for (const item of menuItems) {
    const rowIndex = item.rowIndex || 0;
    if (!rows[rowIndex as keyof typeof rows]) rows[rowIndex] = [];
    rows[rowIndex].push(item);
  }

  const rowArray = Object.values(rows);
  return (
    <Box
      sx={{
        minWidth: 80,
        position: "relative",
      }}
    >
      <Drawer
        variant="permanent"
        sx={{
          "position": collapsed ? "absolute" : "default",
          "width": collapsed ? 80 : drawerWidth,
          "height": "calc(100% - 60px)",
          "transition": theme.transitions.create("width", {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
            delay: "0.2s",
          }),
          "& .MuiDrawer-paper": {
            width: collapsed ? 80 : drawerWidth,
            boxSizing: "border-box",
            marginTop: "60px",
            transition: theme.transitions.create("width", {
              easing: theme.transitions.easing.easeOut,
              duration: theme.transitions.duration.enteringScreen,
              delay: "0.2s",
            }),
            border: "none",
          },
          "&:hover": {
            "width": drawerWidth,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
            },
          },
        }}
      >
        <Grid container spacing={15}>
          {rowArray.map((row: any, index) => (
            <Grid item xs={12} key={index}>
              {index !== 0 ? <Divider /> : null}
              <List
                key={index}
                sx={{
                  "padding": "0px",
                  "& .isActive": {
                    boxShadow: `inset 10px 0px 0px -4px ${theme.palette.primary.main}`,
                  },
                  "min-height": "250px",
                }}
              >
                {row.map((item: any) => {
                  const renderIcon = () => {
                    if (item?.muiIcon) {
                      return item.muiIcon;
                    }
                    if (item?.iconComponent) {
                      const IconComponent = item.iconComponent;
                      return (
                        <IconComponent
                          style={{ height: "16px", fill: "#fff" }}
                        />
                      );
                    }
                    return <Icon icon={item.icon} />;
                  };
                  const isRowActive = (location.pathname as
                    | string
                    | "").includes(item.route);
                  return (
                    <MenuItem
                      key={item.title}
                      selected={isRowActive}
                      onClick={() => history.replace(item.route)}
                      className={isRowActive ? "isActive" : undefined}
                      sx={{
                        height: "60px",
                        padding: "0px",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          justifyContent: "center",
                          width: "80px",
                        }}
                      >
                        {renderIcon()}
                      </ListItemIcon>
                      <ListItemText
                        sx={{
                          "& .MuiListItemText-primary": {
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            fontSize: theme.typography.fontSize,
                            fontWeight: theme.typography.fontWeightBold,
                          },
                        }}
                        primary={item.title}
                      />
                    </MenuItem>
                  );
                })}
              </List>
            </Grid>
          ))}
        </Grid>
      </Drawer>
    </Box>
  );
}
